import { useState } from 'react';
import { CsvExportButton, Flex } from '@elementary/common-ui/components';
import DependenciesTable from 'shared/components/DependenciesTable';
import { DependenciesFilterOptions } from 'shared/components/DependenciesTable/types';
import { useDependenciesData } from 'shared/components/DependenciesTable';

type Props = {
  modelId: string | undefined;
  resource: {
    type: string;
    name?: string;
  };
  editable?: boolean;
};

const Dependencies = ({ modelId, resource, editable }: Props) => {
  const [filter, setFilter] = useState<DependenciesFilterOptions>(
    DependenciesFilterOptions.All,
  );
  const [includeLatestExecution, setIncludeLatestExecution] = useState(false);

  const { data, isLoading, onCSVDownload } = useDependenciesData({
    tableAssetId: modelId,
    resource,
    filter,
    includeLatestExecution,
  });

  return (
    <Flex
      sx={{
        flexDirection: 'column',
        gap: 2,
        position: 'relative',
        height: '100%',
      }}
    >
      <CsvExportButton
        sx={{
          width: 'fit-content',
          alignSelf: 'flex-end',
          position: 'absolute',
          top: 0,
          right: '34px',
        }}
        onClick={onCSVDownload}
        disabled={isLoading}
      />

      {modelId && (
        <DependenciesTable
          modelId={modelId}
          data={data}
          loading={isLoading}
          resource={{ name: modelId, type: 'TABLE' }}
          editable={editable}
          filter={filter}
          setFilter={(f) => {
            setFilter(f as DependenciesFilterOptions);
          }}
          onShowLatestExecution={(val) => setIncludeLatestExecution(val)}
        />
      )}
    </Flex>
  );
};

export default Dependencies;
